module.exports = new __parcel__URL__("home_fly.7d373aa4.webp").toString();